import { forwardRef } from "react";
import { useId } from "react";
function SvgNumberedListSvg({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#333"
        fillRule="evenodd"
        d="M5.849 5.24v3.01h.901v-4.5l-.901-.018-.001.01c-.034.232-.065.445-.223.604-.157.162-.508.255-.75.26v.644l.974-.01ZM9.75 5a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2h-9Zm0 6a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2h-9Zm-5.188.526a1.26 1.26 0 0 1-.025-.136 2.399 2.399 0 0 1-.006-.17c0-.194.034-.379.1-.555a1.381 1.381 0 0 1 .75-.793c.184-.081.394-.122.632-.122.224 0 .427.038.606.115.183.077.337.18.462.312.13.127.227.276.294.447.067.172.1.353.1.542 0 .285-.069.543-.206.773a1.904 1.904 0 0 1-.582.59l-.78.515c-.08.054-.15.113-.213.176a.7.7 0 0 0-.138.223H7.5v.807h-3c0-.194.017-.377.05-.549.033-.176.085-.343.156-.502.075-.158.173-.304.294-.44.12-.14.273-.269.456-.386l.669-.434c.175-.113.298-.228.369-.346a.773.773 0 0 0 .112-.413.628.628 0 0 0-.156-.42c-.1-.122-.252-.183-.456-.183-.217 0-.38.07-.488.21a.85.85 0 0 0-.156.522c0 .081.01.162.031.244l-.819-.027Zm.748 6.02 1.02-.99H4.626v-.806H7.38v.752l-1.008.95c.148.008.29.044.426.107a1.23 1.23 0 0 1 .606.684c.064.164.096.347.096.55 0 .19-.034.373-.102.549a1.418 1.418 0 0 1-.294.468 1.484 1.484 0 0 1-1.098.44c-.228 0-.432-.038-.612-.115a1.47 1.47 0 0 1-.462-.305 1.557 1.557 0 0 1-.306-.447 1.65 1.65 0 0 1-.126-.536l.798-.176a.855.855 0 0 0 .204.556c.132.144.3.216.504.216.208 0 .37-.063.486-.19a.691.691 0 0 0 .174-.474c0-.207-.06-.368-.18-.48a.626.626 0 0 0-.456-.17.91.91 0 0 0-.21.02c-.052.014-.1.03-.144.047l-.366-.65ZM9.75 17a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2h-9Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgNumberedListSvg);
export default ForwardRef;
